import { locais } from "constants/common/formConstants"
import { useRecoilValue } from "recoil"
import { userData } from "schemas"

export const newUSerForm = () => {
    const user = useRecoilValue(userData)

    return [
        {
            fieldId: 'name',
            label: 'Nome completo:',
            placeholder: "Insira o nome completo do colaborador",
            flex: false,
            type: 'text',
            required: true,
        },
        {
            fieldId: 'email',
            label: 'Email:',
            placeholder: "Email do colaborador",
            flex: true,
            required: true,
            type: 'text',
        },
        {
            fieldId: 'local_id',
            label: 'Afecto em:',
            flex: true,
            required: true,
            type: 'select',
            options: [...locais, { label: "Todos Sites", value: 3 }],
        },
        {
            fieldId: 'celular',
            label: 'Celular:',
            placeholder: "Nr do telefone",
            flex: true,
            required: false,
            type: 'text',
        },
        {
            fieldId: 'genero',
            label: 'Gênero',
            flex: true,
            required: true,
            type: 'select',
            options: [
                {
                    label: "Masculino",
                    value: "1",
                },
                {
                    label: "Feminino",
                    value: "0",
                }
            ]
        },
        {
            fieldId: 'departamento',
            label: 'Departamento',
            flex: true,
            required: true,
            type: 'select',
            options: [
                {
                    label: "Administração e Finanças",
                    value: "Administração e Finanças",
                },
                {
                    label: "Operações",
                    value: "Operações",
                },
                {
                    label: "Manutenção",
                    value: "Manutenção",
                },
                {
                    label: "HST",
                    value: "HST",
                },
                {
                    label: "Diretoria Geral",
                    value: "Diretoria Geral",
                }
            ]
        },
        {
            fieldId: 'funcao',
            label: 'Função:',
            placeholder: "Função do colaborador",
            flex: true,
            required: false,
            type: 'text',
        },
        // {
        //     fieldId: 'tipo',
        //     label: 'Tipo:',
        //     flex: true,
        //     required: true,
        //     type: 'text'
        // },
        {
            fieldId: 'efectivo',
            label: 'Efectivo?',
            flex: true,
            required: true,
            radioFlex: true,
            type: 'radio',
            options: [
                {
                    label: "Sim",
                    value: "1",
                },
                {
                    label: "Não",
                    value: "0",
                }
            ]
        },
        {
            fieldId: 'acesso',
            label: 'Tipo de acesso?',
            flex: true,
            required: true,
            type: 'radio',
            options: [
                ...(user?.acesso != '1' ? [{
                    label: "Normal",
                    value: "1",
                }] : []),

                ...(user?.acesso == '3' ? [
                    {
                        label: "Site manager",
                        value: "2",
                    },
                    {
                        label: "National manager",
                        value: "3",
                    }
                ] : [])
            ]
        },
    ]
}